import React from 'react';

const features = [
  {
    id: 'feat-budget',
    icon: '💰',
    title: 'Budget at a glance',
    desc: 'See your monthly spending vs. budget in real time.',
  },
  {
    id: 'feat-categories',
    icon: '📊',
    title: 'Spending by category',
    desc: 'Food, transport, bills — know exactly where money goes.',
  },
  {
    id: 'feat-log',
    icon: '✏️',
    title: 'Log in seconds',
    desc: 'Add a transaction with amount, category, date, and note.',
  },
];

export default function AuthBrandPanel() {
  return (
    <div className="hidden lg:flex lg:w-[520px] xl:w-[580px] flex-col justify-between p-12 gradient-primary relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-10 bg-white" />
        <div className="absolute bottom-10 -left-16 w-64 h-64 rounded-full opacity-8 bg-white" />
        <div className="absolute top-1/2 right-8 w-32 h-32 rounded-full opacity-5 bg-white" />
      </div>
      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-16">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-lg">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <rect x="2" y="13" width="4" height="7" rx="1.5" fill="var(--primary)" fillOpacity="0.5" />
              <rect x="8" y="9" width="4" height="11" rx="1.5" fill="var(--primary)" fillOpacity="0.75" />
              <rect x="14" y="4" width="4" height="16" rx="1.5" fill="var(--primary)" />
              <circle cx="17" cy="2.5" r="2" fill="var(--accent)" />
            </svg>
          </div>
          <span className="text-xl font-bold text-white tracking-tight">FinanceTracker</span>
        </div>

        {/* Hero copy */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-white leading-tight mb-4">
            Know where your<br />money actually goes.
          </h1>
          <p className="text-blue-100 text-lg leading-relaxed">
            Log transactions, track budgets by category, and stay on top of your spending — without the spreadsheet.
          </p>
        </div>

        {/* Feature list */}
        <div className="space-y-5">
          {features?.map((f) => (
            <div key={f?.id} className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center text-lg flex-shrink-0">
                {f?.icon}
              </div>
              <div>
                <p className="text-white font-semibold text-sm">{f?.title}</p>
                <p className="text-blue-100 text-sm mt-0.5">{f?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom stats bar */}
      <div className="relative z-10 grid grid-cols-3 gap-4 pt-8 border-t border-white/20">
        {[
          { id: 'stat-free', val: 'Free', label: 'Always free' },
          { id: 'stat-private', val: '100%', label: 'Private data' },
          { id: 'stat-instant', val: '<5s', label: 'Log a transaction' },
        ]?.map((s) => (
          <div key={s?.id} className="text-center">
            <p className="text-white text-xl font-bold font-tabular">{s?.val}</p>
            <p className="text-blue-200 text-xs mt-0.5">{s?.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}